import { MutableRefObject, useEffect } from 'react';
import { Slide, toast } from 'react-toastify';

import { GridApiPro } from '@mui/x-data-grid-pro';

import TableInstance from '@/shared/constants/tableInstance';

import SnackToolbar, { SnackToolbarProps } from '../components/SnackToolbar';

type Args = {
  apiRef: MutableRefObject<GridApiPro>;
  snackBarProps?: Partial<SnackToolbarProps>;
  tableInstance?: TableInstance;
};

const useTableSnackBar = ({ apiRef, snackBarProps, tableInstance }: Args) => {
  useEffect(() => {
    const selection = apiRef.current.getSelectedRows();

    if (snackBarProps && selection.size > 0 && tableInstance) {
      const render = (
        <SnackToolbar
          apiRef={apiRef}
          selectedRows={selection.size}
          instanceId={tableInstance}
          actions={snackBarProps.actions}
          onClose={() => toast.dismiss(tableInstance)}
        />
      );

      if (toast.isActive(tableInstance)) {
        toast.update(tableInstance, { render });
      }

      toast(render, { toastId: tableInstance, transition: Slide });
    } else {
      toast.dismiss(tableInstance);
    }
  }, [apiRef, snackBarProps, tableInstance]);
};

export default useTableSnackBar;
